export const AUTH_TOKEN = '@575b684d59f6cc80e6e5783e81bbff48'
export const AUTH_LOGGED_COMPANY = '@c962c335e8dfac15a69756128e6e32bc'
export const TOKEN_PRE_REGISTRATION = '@dponet-pre-registration'
export const TOKEN_LOGGED_COMPANY = '@3cbef9d8eb62c2798f193989fe8db517'
export const TOKEN_SUPPLIER_INVITE = '@dponet-supplier-invite'
export const DPONET_PARTNER = '@dponet-partner'
export const RIPD_INCITE_EXPORTED = '@ripd-incited-exported'
export const COOKIE_AUTH_TOKEN = '@cookie-auth-token'
export const COMPLAINT_TWO_FACTOR_AUTH_TOKEN =
  '@complaint-two-factor-auth-token'
export const COMPANY_SUPPLIER_AUTH_TOKEN = '@company-supplier-auth-token'
export const COMPANY_SUPPLIER_TOKEN = '@company-supplier-token'
export const COMPANY_SUPPLIER_PORTAL_TOKEN = '@company-supplier-portal-token'
export const COMPANY_SUPPLIER_PORTAL_SLUG = '@company-supplier-portal-slug'
export const GUEST_AUTH_TOKEN = '@guest-auth-token'
export const GUEST_PORTAL_TOKEN = '@guest-portal-token'
export const TRAINING_AUTH_TOKEN = '@training-auth-token'
export const TRAINING_PORTAL_TOKEN = '@training-portal-token'
export const ORGANIZATION_SLUG = '@dponet-organization-slug'
